export const formatOptionSelect = (elem: any) => {
  return {
    label: elem?.name,
    value: elem?.id ?? elem?.identifier,
    more: { ...elem },
  }
}
